import React, { useEffect, useRef, useState } from "react";
import { Props } from "../paywall";
import PaywallInlineSignup from "../paywall-inline-signup";
import PaywallInlineSignupTest from "../goat-464-test/paywall-inline-signup";
import FzBraze, { TRACKING_PROPERTY } from "../../../../../../javascript/FzBraze";
import params from "../../../../../../javascript/utils/params";
import { BrazeAttributes } from "../../../../../../javascript/interface";
import { sendAccountChangeEvent } from "../../../../../javascript/utils";
import style from '../paywall-comp.module.scss';
import { PaywallInlinePayment } from "../paywall-inline-payment";
import Geoblock from "../geoblock";

export interface Campaign {
  token: string
}

export interface CampaignDetails {
  campaign: Campaign
  link: string
  cta: string
  recurring: string | null
  pricing_strings: any
}

interface PaywallState {
  account: {
    id: string,
    email: string
  },
  signed_in: boolean
  campaign_details: CampaignDetails | null
  mode: modes
  trial_activated: boolean
}

export type modes = "CURRENT_CAMPAIGN_LOGGED_IN" | "CURRENT_CAMPAIGN_LOGGED_OUT" | "LOGGED_IN_WITH_TRIAL_SUBSCRIPTION" | "LOGGED_IN_WITH_SUBSCRIPTION" | "LOGGED_IN_TRIAL_ELIGIBLE" | "LOGGED_OUT_TRIAL_ELIGIBLE" | "LOGGED_IN_NO_SUBSCRIPTION_STANDARD_CAMPAIGN" | "LOGGED_IN_WITH_EXPIRED_SUBSCRIPTION" | "LOGGED_IN_WITH_EXPIRED_TRIAL";
type ModeSimplified = 'login' | 'paywall' | 'done'


export interface PaywallTranslations {
  [key: string]: string
}

export interface ViewProps extends Props, PaywallState { }

export default function ArticlePaywall(props: Props) {
  const [state, setState] = useState<PaywallState>(null);
  const [stateModeSimplified, setStateModeSimplified] = useState<ModeSimplified>(null)
  const [newUser, setNewUser] = useState(null)
  const [geoblockOpen, setGeoblockOpen] = useState(props.should_show_geoblock);
  const [heightSetOnce, setHeightSetOnce] = useState(false)
  const containerRef = useRef(null);

  const searchParams = new URLSearchParams(window.location.search);
  const trialCampaignToken = searchParams.get("tcto") || "";

  const getUserState = async () => {
    const campaignToken = searchParams.get("cto") || searchParams.get("campaign_token_override") || "";

    const response = await fetch(`${props.get_paywall_data_url}?campaign_token_override=${campaignToken}&campaign_tag_override=${props.clg_paywall ? "readly-com-standard-clg-paid" : "readly-com-standard-seo-organic"}`);
    const body: PaywallState = await response.json()

    setState(body);
    console.log(body)
    if (body.mode == "LOGGED_OUT_TRIAL_ELIGIBLE" || body.mode == "CURRENT_CAMPAIGN_LOGGED_OUT") {
      setStateModeSimplified('login');
    } else if (body.mode == 'CURRENT_CAMPAIGN_LOGGED_IN' || body.mode == 'LOGGED_IN_WITH_TRIAL_SUBSCRIPTION' || body.mode == 'LOGGED_IN_WITH_EXPIRED_SUBSCRIPTION' || body.mode == 'LOGGED_IN_WITH_EXPIRED_TRIAL') {
      setStateModeSimplified('paywall');
    } else if (body.mode == 'LOGGED_IN_WITH_SUBSCRIPTION' || true) {
      // In the cases where we don't have a set state for the mode, lets default here as well. Keep the || true above for now
      setStateModeSimplified('done')
    }

    if (stateModeSimplified == 'paywall' && containerRef.current) {
      containerRef.current.scrollBy(0, window.innerHeight / 2);
    }
    if (body.trial_activated) {
      sendAccountChangeEvent();
    }
  }

  useEffect(() => {
    if (state && !state.signed_in) {
      // Need to set initial braze tracking on page load
      TrackBrazeUser()
    }
  }, [state])

  useEffect(() => {
    (async () => {
      try {
        getUserState();
      } catch (e) {
        setState(null)
      }
    })();
  }, [])

  useEffect(() => {
    const e = containerRef.current
    if (e) {
      e.scrollTop = 0;
    }
  }, [containerRef])

  useEffect(() => {
    if (!heightSetOnce && stateModeSimplified == 'paywall' && containerRef.current) {
      containerRef.current.scrollBy(0, window.innerHeight / 2);
      setHeightSetOnce(true)
    }
  }, [stateModeSimplified])

  useEffect(() => {
    const wheelEvent = (e) => {
      if (containerRef.current) {
        // console.log(containerRef.current)
        // console.log(containerRef.current.scrollY, e.deltaY)
        containerRef.current.scrollTop += e.deltaY;
      }
    }
    if (state && stateModeSimplified != 'done') {
      document.documentElement.scrollTop = 0;
      document.documentElement.style.overflow = 'hidden'
      // window.addEventListener('wheel', wheelEvent)
    } else {
      document.documentElement.style.overflow = 'initial'
    }

    return () => {
      document.documentElement.style.overflow = 'initial'
      document.removeEventListener('wheel', wheelEvent)
    }
  }, [state, containerRef, stateModeSimplified])

  const setPaywallMode = (mode: modes) => {
    let tempState = Object.assign({}, state);
    tempState.mode = mode;
    setState(tempState);
  }

  const trackingChannel = window.location.pathname.split('/')[1];
  const clgChannel = props.clg_paywall ? trackingChannel : 'seo';

  useEffect(() => {
    const fromCountry = searchParams.get('fromCountry')
    if (fromCountry) {
      window.dataLayer.push({
        event: "clg",
        clg_channel: clgChannel,
        step: `landing_redirect_from_${fromCountry.toUpperCase()}`,
        item_id: `${props.article_id}`
      })
    } else {
      window.dataLayer.push({
        event: "clg",
        clg_channel: clgChannel,
        step: "landing",
        item_id: `${props.article_id}`
      })
    }

    if (geoblockOpen) {
      window.dataLayer.push({
        event: "clg",
        clg_channel: clgChannel,
        step: "pw_21_oops_screen",
        item_id: `${props.article_id}`
      })
    }
  }, [])

  useEffect(() => {
    if (stateModeSimplified == 'login' && !geoblockOpen) {
      window.dataLayer.push({
        event: "clg",
        clg_channel: clgChannel,
        step: "pw_31_signup_screen",
        item_id: `${props.article_id}`
      })
    }
  }, [stateModeSimplified, geoblockOpen])

  const onClickGoToReadlyGeo = () => {
    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: `pw_22_oops_goto_${props.geo_country.toUpperCase()}`,
      item_id: `${props.article_id}`
    })
  }

  const onClickContinueGeo = () => {
    setGeoblockOpen(false);

    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_23_oops_continue",
      item_id: `${props.article_id}`
    })
  }

  const onValidEmailEntered = () => {
    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_32_signup_continue",
      item_id: `${props.article_id}`
    })
  }

  const onCreatePasswordShown = () => {
    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_32_signup_continue",
      item_id: `${props.article_id}`
    })
  }

  const onCountryChange = (country: string) => {
    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: `pw_42_createpw_selected_${country.toLowerCase()}`,
      new_country: country,
      item_id: `${props.article_id}`
    })
  }

  const onEmailExists = () => {
    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_4b1_existing_screen",
      item_id: `${props.article_id}`
    })
  }

  const onSignInAccountExistsInDifferentCountryWithArticleAvailable = (accountCountry) => {
    if (props.article_distributions.includes(accountCountry)) {
      window.dataLayer.push({
        event: "clg",
        clg_channel: clgChannel,
        step: `pw_4c_article_found_in_${accountCountry}`,
        item_id: `${props.article_id}`
      })
    }
  }

  const onRegister = (brazeAttributes: BrazeAttributes, trackingObject: Object) => {
    getUserState();
    TrackBrazeUser(brazeAttributes)
    console.log("onRegister", brazeAttributes)
    sendAccountChangeEvent();
    window.dataLayer.push(trackingObject);
    setNewUser(true)

    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_43_createpw_signup_success",
      item_id: `${props.article_id}`
    })
  }

  const onSignin = (_account: any, trackingObject: any) => {
    sendAccountChangeEvent();
    getUserState();
    trackingObject['method'] = props.clg_paywall ? "clg_article_paywall" : "article_paywall";
    window.dataLayer.push(trackingObject);
    setNewUser(false)

    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_4b2_existing_login_success",
      item_id: `${props.article_id}`
    })
  }

  const onSuccessfulPayment = () => {
    setPaywallMode('LOGGED_IN_WITH_SUBSCRIPTION')
    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_52_checkout_success",
      item_id: `${props.article_id}`
    })
    sendAccountChangeEvent();
  }

  const onPaymentPageLoaded = () => {
    window.dataLayer.push({
      event: "clg",
      clg_channel: clgChannel,
      step: "pw_51_checkout_screen",
      user: newUser ? "new" : "existing",
      item_id: `${props.article_id}`
    })
  }

  const TrackBrazeUser = (brazeAttributes?: BrazeAttributes) => {
    const BrazeUser = new FzBraze()
    const articleId = window.location.pathname.split("/")[4];
    const trackingParams = {
      acquisition_article_id: articleId,
      acquisition_campaign_id: params[TRACKING_PROPERTY.utm_campaign] || "N/A",
      acquisition_category_name: params[TRACKING_PROPERTY.utm_content] || "N/A"
    }
    if (brazeAttributes) {
      FzBraze.commitUser(brazeAttributes.email, brazeAttributes.account_id)
      FzBraze.changeUser(brazeAttributes.account_id)
      BrazeUser.setCustomAttributes([trackingParams])
    } else {
      BrazeUser.defineNewUser()
      BrazeUser.setCustomAttributes([trackingParams])
    }
  }

  if (!state || stateModeSimplified == 'done') return null;

  console.log(state, stateModeSimplified)

  return (
    <>
      <div className={[style.articlePaywallContainer, 'ds-light-theme'].join(' ')} ref={containerRef}>
        <div className={[style.articlePaywallContent, stateModeSimplified == 'paywall' ? style.minHeightFullVh : ''].join(' ')}>

          {(() => {
            if (geoblockOpen && stateModeSimplified == 'login') {
              return <Geoblock {...props} onClickContinue={onClickContinueGeo} onClickGoToReadlyGeo={onClickGoToReadlyGeo} />
            } else if (stateModeSimplified == 'login') {
              if (props.article_paywall_copy_variation != 'default') { //If it's a non standard paywall test
                return <PaywallInlineSignupTest
                  campaignDetails={state.campaign_details}
                  translations={props.translations}
                  onRegister={onRegister}
                  onSignin={onSignin}
                  onCountryChange={onCountryChange}
                  freeTrialTag={trialCampaignToken ? "" : (props.clg_paywall ? 'readly-com-clg-paid' : 'readly-com-seo-organic')}
                  freeTrialCampaignToken={trialCampaignToken}
                  currentCountry={props.current_country.toLocaleLowerCase()}
                  countrySelectOptions={props.country_selector_options}
                  topPublications={props.top_publications}
                  onValidEmailEntered={onValidEmailEntered}
                  onCreatePasswordShown={onCreatePasswordShown}
                  onEmailExists={onEmailExists}
                  articleDistributions={props.article_distributions}
                  onSignInAccountExistsInDifferentCountryWithArticleAvailable={onSignInAccountExistsInDifferentCountryWithArticleAvailable}
                  testVersion={props.article_paywall_copy_variation}
                  clg_paywall_bullets_test_enabled={props.clg_paywall_bullets_test_enabled}
                />
              }
              return <PaywallInlineSignup
                campaignDetails={state.campaign_details}
                translations={props.translations}
                onRegister={onRegister}
                onSignin={onSignin}
                onCountryChange={onCountryChange}
                freeTrialTag={trialCampaignToken ? "" : (props.clg_paywall ? 'readly-com-clg-paid' : 'readly-com-seo-organic')}
                freeTrialCampaignToken={trialCampaignToken}
                currentCountry={props.current_country.toLocaleLowerCase()}
                countrySelectOptions={props.country_selector_options}
                topPublications={props.top_publications}
                onValidEmailEntered={onValidEmailEntered}
                onCreatePasswordShown={onCreatePasswordShown}
                onEmailExists={onEmailExists}
                articleDistributions={props.article_distributions}
                onSignInAccountExistsInDifferentCountryWithArticleAvailable={onSignInAccountExistsInDifferentCountryWithArticleAvailable}
              />
            } else if (stateModeSimplified == 'paywall') {
              return <PaywallInlinePayment
                onSuccessfulPayment={onSuccessfulPayment}
                onPaymentPageLoaded={onPaymentPageLoaded}
                onCloseModal={() => setStateModeSimplified('done')}
                translations={props.translations}
                campaign={state.campaign_details}
              />
            }
          })()}
        </div>
      </div>
    </>
  );
}
